import Item from '../../inspect/components/tracker/item'

export const convertNutritionixData = (itemDetails) => {
  const unitLowerCased = itemDetails.serving_unit.toString().toLowerCase()

  const data = {
    name: (itemDetails.food_name) ? (itemDetails.food_name).toString() : '',
    customServing: {
      servingWeightGrams: (itemDetails.serving_weight_grams) ? Number(itemDetails.serving_weight_grams).toFixed(1) : 0, 
      unit: (itemDetails.serving_unit && unitLowerCased !== 'g' && unitLowerCased !== 'grams' && unitLowerCased !== 'oz' && unitLowerCased !== 'ounces') ? unitLowerCased : 'serving'
    },
    baseCalories: (itemDetails.nf_calories) ? Number(itemDetails.nf_calories).toFixed(1) : '0',
    baseProtein: (itemDetails.nf_protein) ? Number(itemDetails.nf_protein).toFixed(1) : '0',
    baseCarbs: (itemDetails.nf_total_carbohydrate) ? Number(itemDetails.nf_total_carbohydrate).toFixed(1) : '0',
    baseFat: (itemDetails.nf_total_fat) ? Number(itemDetails.nf_total_fat).toFixed(1) : '0',
    baseGrams: (itemDetails.serving_weight_grams) ? Number(itemDetails.serving_weight_grams).toFixed(1) : '0',
    baseFiber: (itemDetails.nf_dietary_fiber) ? Number(itemDetails.nf_dietary_fiber).toFixed(1) : '0',
    baseSize: (itemDetails.serving_qty) ? (itemDetails.serving_qty).toString() : '',
    baseUnit: (itemDetails.serving_unit) ? unitLowerCased : '',
    serving: (itemDetails.serving_qty) ? (itemDetails.serving_qty).toString() : '',
    thumbnailUrl: (itemDetails.photo.thumb) ? (itemDetails.photo.thumb) : '',
  }

  if (data.baseUnit === 'g' || data.baseUnit === 'grams') {
    data.baseSize = 1
    data.baseGrams = data.serving
    data.customServing.servingWeightGrams = data.serving
  } else if (data.baseUnit === 'oz' || data.baseUnit === 'ounces' ) {
    const weightGrams = Math.round((Number(data.serving) * 28.3495) * 10) / 10

    data.baseSize = 1
    data.baseGrams = weightGrams
    data.customServing.servingWeightGrams = weightGrams
  }

  const newItem = new Item(data)
  
  return newItem
}